module.exports = __webpack_public_path__ + "img/news_blog.2783b085.svg";